import Marquee from "react-fast-marquee";
import { BOTANICALS } from "@/data/botanicals";

const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="relative py-8 border-y border-[#C5A880]/20 bg-[#041a0f] overflow-hidden">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {BOTANICALS.map((b) => (
        <span key={b.id} className="flex items-center mx-12">
          <span className="font-display italic text-2xl md:text-3xl text-[#F5F1E8]/85">{b.name}</span>
          <span className="ml-4 text-xs uppercase tracking-[0.25em] text-[#C5A880]/70">{b.tagline}</span>
          <span className="ml-12 text-[#C5A880]">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
